import { render, staticRenderFns } from "./ReworkNew.vue?vue&type=template&id=567ae386"
import script from "./ReworkNew.vue?vue&type=script&lang=js"
export * from "./ReworkNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports